import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Search = () => {
    const [keyword, setKeyword] = useState("");
    const navigate = useNavigate();

    const submitHandler = (e) => {
        e.preventDefault();
        if (keyword?.trim()) {
            navigate(`/?keyword=${keyword}`);
        } else {
            navigate(`/`);
        }
    };

    return (
        <form
            onSubmit={submitHandler}
            className="jewellery-search d-flex justify-content-center w-100"
        >
            <input
                type="text"
                className="form-control rounded-pill "
                placeholder="🔍 Search Trinkets & Treasures..."
                name="keyword"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                style={{
                    maxWidth: "360px", // perfect for Galaxy Z Fold 5 width
                    width: "90%",
                    fontSize: "14px",
                    padding: "8px 14px",
                }}
            />
        </form>
    );
}

export default Search;